import React, {useContext, useEffect, useState} from 'react';

import {Alert, Icon, Typography} from '@bonprix/design-system';
import {ShowCouponInfoAccordionContext} from '@checkout/components/cart/Cart.jsx';
import Expand100 from '@checkout/components/common/Expand100.jsx';
import LandmarkAdapter from '@core/scripts/components/landmark-adapter';
import {couponValidation} from '@core/scripts/helper/form-input-validation/inputFieldValidations';
import RhfTextField from '../../common/forms/fields/RhfTextField.jsx';
import Form from '../../common/forms/Form.jsx';
import RhfSubmitButton from '../../common/forms/RhfSubmitButton.jsx';

export default function CouponInput({
                                        texts,
                                        submitHandler,
                                        pending,
                                        couponError,
                                        onCouponInput,
                                        prefilledValue,
                                        isLastCheckPage,
                                        onDeleteCoupon
                                    }) {
    const [couponValue, setCouponValue] = useState(prefilledValue);
    const {showCouponInfoAccordion, setShowCouponInfoAccordion} = useContext(ShowCouponInfoAccordionContext);
    const [couponLandmarkWasSent, setCouponLandmarkWasSent] = useState(false);

    const onSubmit = (values) => {
        if(values?.coupon){
            onCouponInput();
            LandmarkAdapter.sendClickLandmark((isLastCheckPage ? 'lastcheck' : 'cart') + '_code_redeem');
            return submitHandler(values.coupon);
        }
    };

    // workaround, as the Text component in the PaLi does not pass it's onCloser attribute to the Deletable component
    useEffect(() => {
        let closer = document.getElementsByClassName('input__closer')[0];
        if (closer) {
            closer.onclick = () => LandmarkAdapter.sendClickLandmark((isLastCheckPage ? 'lastcheck' : 'cart') + '_code_delete');
        }
    }, [couponValue]);

    const handleChange = (value) => {
        if (!value) {
            onDeleteCoupon();
        }
        setCouponValue(value);
        setShowCouponInfoAccordion(false);
    };

    let cvpHint = null;
    if (couponValue === 'CODE') {
        cvpHint = (
            <div className="mb-5">
                <Alert isOpen severity={'info'} showCloseIcon={false}>
                    {texts.cvp_checkout_infotext}
                </Alert>
            </div>
        );
    }

    function onClickCouponError() {
        if (!couponLandmarkWasSent) {
            LandmarkAdapter.sendClickLandmark('bonusCode_invalid_reason_info');
            setCouponLandmarkWasSent(true);
        }
    }

    let couponErrorSolutions = null;
    const serviceIcon = (
        <div className={'cart__coupon__error__solutions__label__icon'}>
            <Icon variant='service'/>
        </div>);
    if (showCouponInfoAccordion) {
        couponErrorSolutions =
            <div className="mt-3.5">
                <Expand100 label={texts.cot09_coupon_not_applied_headline}
                           labelIcon={serviceIcon}
                           classes={'cart__coupon__error__solutions'}
                           onToggle={onClickCouponError}
                           variant={'body2'}>
                    <div className="cart__coupon__error__solutions__label">
                        <ul className="list-disc list-inside pl-1 mt-3.5">
                            <li><Typography variant={'body2'}
                                            component="span">{texts.cot09_coupon_not_applied_reason_1}</Typography></li>
                            <li><Typography variant={'body2'}
                                            component="span">{texts.cot09_coupon_not_applied_reason_2}</Typography></li>
                            <li><Typography variant={'body2'}
                                            component="span">{texts.cot09_coupon_not_applied_reason_3}</Typography></li>
                            <li><Typography variant={'body2'}
                                            component="span">{texts.cot09_coupon_not_applied_reason_4}</Typography></li>
                        </ul>
                    </div>
                </Expand100>
            </div>;

    }
    return (
        <Form
            className="flex flex-row flex-wrap"
            defaultValues={{coupon: prefilledValue || ''}}
            onSubmit={onSubmit}
        >
            {cvpHint}
            <RhfTextField
                name={'coupon'}
                helperText={texts.cot_coupon_example}
                label={texts.cot09_enter_coupon}
                validation={couponValidation(texts)}
                errorText={couponError}
                onChange={handleChange}
            />
            {couponErrorSolutions}
            <div className="cart__coupon__button-wrapper mt-3.5">
                <RhfSubmitButton
                    variant="primary"
                    disabled={!couponValue}
                    loading={pending}
                    fullWidth={true}
                    onSubmit={onSubmit}
                >
                    {texts.cot3_redeem_voucher}
                </RhfSubmitButton>
            </div>
        </Form>
    );
}
